import { isServer } from "./nextLib";

const methodMap = [
  "requestFullscreen",
  // new webkit
  "webkitRequestFullscreen",
  "webkitEnterFullScreen",
  // old webkit
  "webkitRequestFullScreen",
  "mozRequestFullScreen",
  "msRequestFullscreen",
];

type MethodReturnType = Promise<undefined> | undefined;

export function requestFullscreen(element: Element) {
  if (isServer()) {
    return;
  }

  for (const methodName of methodMap) {
    if (methodName in element) {
      // handle full screen error
      (
        element[methodName as keyof Element] as () => MethodReturnType
      )()?.catch?.((e) => {
        console.log(e);
      });
      return;
    }
  }
}
